import { Link, useLocation, useSearchParams } from 'react-router';

import type { ProductVariantCardFragment } from '@boc/framework/saleor-graphql';

import { buttonVariants } from '~/local/components/button';

export const ResetPagination = () => {
  let [searchParams] = useSearchParams();

  const hasAfter = searchParams.has('after');

  [searchParams] = useSearchParams();
  searchParams.delete('after');
  const navigationReset = searchParams.toString();

  const { state } = useLocation();

  if (state?.previousProducts) {
    return null;
  }

  if (!hasAfter) {
    return null;
  }

  return (
    <div className="flex justify-center">
      <Link
        to={{ search: navigationReset }}
        preventScrollReset={true}
        className={buttonVariants({ intent: 'primary' })}
      >
        Load Previous
      </Link>
    </div>
  );
};

export const Pagination = ({
  products,
  next,
}: {
  products: ProductVariantCardFragment[];
  next?: string;
}) => {
  const [searchParams] = useSearchParams();

  if (!next) {
    return null;
  }

  searchParams.set('after', next || '');
  const navigationNext = searchParams.toString();

  return (
    <div className="flex justify-center">
      <Link
        to={{ search: navigationNext }}
        state={{ previousProducts: products }}
        preventScrollReset={true}
        prefetch="intent"
        className={buttonVariants({ intent: 'primary', className: 'hidden lg:block' })}
      >
        Load More
      </Link>
      <Link
        to={{ search: navigationNext }}
        state={{ previousProducts: products }}
        preventScrollReset={true}
        prefetch="viewport"
        className={buttonVariants({ intent: 'primary', className: 'lg:hidden' })}
      >
        Load More
      </Link>
    </div>
  );
};
